export var resetNotificationListStore = function resetNotificationListStore() {
  return function (_ref) {
    var setState = _ref.setState;
    setState({
      ids: [],
      notifications: {},
      filterStates: {},
      groups: []
    });
  };
};